import Fuse from "fuse.js";
import image from "@/assets/imgs/user-profile.png";

// Parameters:
// -----------
//
// Returns
// -----------
// Fusejs Search Config for Products Module
export const fuseConfigProducts = {
  keys: [
    {
      name: "name",
      weight: 0.9
    },
    {
      name: "sku",
      weight: 0.7
    }
  ],
  includeScore: true,
  shouldSort: true,
  threshold: 0.36,
  findAllMatches: true
};
// Parameters:
// -----------
// search
// list
//
// Returns
// -----------
// List of Products filtered by Fusejs used in MultiSelect Component
export const searchMultiselectFilterHelper = (search, list) => {
  let result = list;
  if (search !== "" && search !== null) {
    const fuse = new Fuse(list, fuseConfigProducts);
    result = fuse.search(search).map((res) => res.item);
  }
  return result;
};
// Parameters:
// -----------
// email
//
// Returns
// -----------
// URL for staff avatar hosted in AWS
export const getAvatar = (email) => {
  switch (email) {
    case "meganw@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Megan+Watson.jpg";
    case "ashley@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Ashleigh.jpeg";
    case "leandro@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Leandro+Barbosa.jpg";
    case "arron@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Aaron+Hall.jpg";
    case "tony@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Tony+Williams.jpg";
    case "peta@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Peta+Beech.jpg";
    case "amy@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Amy+Scicluna.jpg";
    case "kiara@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Kiara+Jones.jpg";
    case "kayla@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Kayla+Duncan.jpg";
    case "estra@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Estra+La+Bonya.jpg";
    case "tari@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Tari+Peterson.jpg";
    case "cahlee@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Cahlee+Bland.jpg";
    case "rhys@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Rhys.jpeg";
    case "brookes@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Brooke+Spain.jpg";
    case "leigh@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Leigh+McMahon.jpg";
    case "alyse@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Alyse+Judd.jpg";
    case "josh@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Josh.jpeg";
    case "ruby@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Ruby+Duncan.jpg";
    case "luli@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Luli.jpeg";
    case "charlie@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Charlie.jpeg";
    case "connor@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Connor+Dye.jpg";
    case "zoe@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Zoe+Jones.jpg";
    case "ali@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Aleisha+Parkes.jpg";
    case "oliver@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Oliver+Pfeiffer.jpg";
    case "natasha@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Natasha+Greenaway.jpg";
    case "megan@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Megan+Fletcher.jpg";
    case "tess@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Tess+Lovell.jpg";
    case "samantha@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Samantha+Godfrey.jpg";
    case "lauren@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Lauren+Bell.jpg";
    case "denver@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Denver+Anderson.jpg";
    case "harneet@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Harneet+Kaler.jpg";
    case "renee@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Renee+Enoka.jpg";
    case "gabrielle@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Gabrielle+Hows.jpg";
    case "chanelle@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Chanelle+Johnston.jpg";
    case "tim@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Tim+Willoughby.jpg";
    case "wayne@abi-international.com.au":
      return "https://productteam.s3.ap-southeast-2.amazonaws.com/Wayne+He.png";
    case "jade@abi-international.com.au":
      return "https://www.clipartmax.com/png/middle/2-25113_iron-man-chibi-by-joeleon-dag5phv-iron-man-cartoon-png.png";
    default:
      return image;
  }
};

export const checkImgExists = (imgUrl) => {
  return new Promise((resolve, reject) => {
    let ImgObj = new Image();
    ImgObj.src = imgUrl;
    ImgObj.onload = (res) => {
      resolve(res);
    };
    ImgObj.onerror = (err) => {
      reject(err);
    };
  });
};
